module.exports = __webpack_public_path__ + "static/img/rank_64.c363862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_64.png
// module id = 8jNB
// module chunks = 0